import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import tra_haz_lev from "../img/sswpIcons/Traffic/tra_haz_lev.png";
import tra_2_way_tra from "../img/sswpIcons/Traffic/tra_2_way_tra.png";
import tra_add_sig from "../img/sswpIcons/Traffic/tra_add_sig.png";
import tra_all from "../img/sswpIcons/Traffic/tra_all_sto.png";
import tra_giv_and_tak from "../img/sswpIcons/Traffic/tra_giv_tak.png";
import tra_hiv_tru from "../img/sswpIcons/Traffic/tra_hi_vis_tru.png";
import tra_ipv from "../img/sswpIcons/Traffic/tra_imp_pro_veh.png";
import tra_les from "../img/sswpIcons/Traffic/tra_15_min.png";
import tra_lia_per from "../img/sswpIcons/Traffic/tra_lia_per.png";
import tra_lig from "../img/sswpIcons/Traffic/tra_lig.png";
import tra_par from "../img/sswpIcons/Traffic/tra_par.png";
import tra_pri from "../img/sswpIcons/Traffic/tra_pri.png";
import tra_sem_sta from "../img/sswpIcons/Traffic/tra_sem_sta.png";
import tra_spe_con from "../img/sswpIcons/Traffic/tra_spe_con_con.png";
import tra_sta_pla from "../img/sswpIcons/Traffic/tra_sta_pla.png";
import tra_sto_and_go from "../img/sswpIcons/Traffic/tra_sto_and_go.png";
import tra_tra_sig from "../img/sswpIcons/Traffic/tra_tra_sig.png";
import tra_veh_res_sys from "../img/sswpIcons/Traffic/tra_veh_res_sys.png";
import tra_mob_roa from "../img/sswpIcons/Traffic/tra_mob_roa.png";
import tra_vis from "../img/sswpIcons/Traffic/tra_vis.png";
import tra_sit_spe_met from "../img/sswpIcons/Traffic/tra_sit_spe_met.png";

const json = {
    icon: tra_haz_lev,
    name: "Traffic",
    text: (
        <ul>
            <ListItem text="Traffic Control plans must be prepared, to help plan and control traffic movement, especially atthe entrance to any construction site. Measures to control traffic may include the following: useof warning signs, bollards, stop-go systems,ramps, temporary traffic lights, and flagmen.Liaison with local Gardaí may also be necessary.The Department of the Environment’s TrafficSigns Manual should be referred to." />
        </ul>
    ),
    icons: {
        tra_15_min: {
            name: "< 15 Min",
            icon: tra_les,
            text: (
                <ul>
                    <ListItem text="Small scale works that can be planned to be finished in ≤ 15 minutes, in low traffic volumes, can be carried out provided workers are not exposed to live traffic, and the works do not present a hazard to live traffic." />
                </ul>
            )
        },
        tra_hi_vis_tru: {
            name: "Hi-Vis Truck/ Fend/ Sign",
            icon: tra_hiv_tru,
            text: (
                <Li>
                    <Typography variant="title">
                        Can only be used when all of the following conditions
                        are met
                    </Typography>
                    <ol>
                        <ListItem text="Once off, discrete location" />
                        <ListItem text="Works < 15 minutes" />
                        <ListItem text="Traffic < 48 vehicles/ 3 minutes (both directions)" />
                        <ListItem text="Vehicle parked safely, with sufficient visibility" />
                        <ListItem text="Vehicle warning beacons operating/ Roadworks ahead sign on display" />
                        <ListItem text="Operative working off the live lane, or between 2m and 5m ahead of the fend vehicle (and 1.2m from vehicle edge line)" />
                    </ol>
                </Li>
            )
        },
        tra_vis: {
            name: "Visibility",
            icon: tra_vis,
            text: (
                <ul>
                    <ListItem text="Visibility is one of the major risk factors effecting the likelihood of something happening." />
                    <Li>
                        <Typography variant="title">
                            As guidance, the table indicated Poor, Good and Very
                            Good visibility distances for different speeds.
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th />
                                    <th>Poor</th>
                                    <th>Good</th>
                                    <th>Very Good</th>
                                </tr>
                                <tr>
                                    <td>30 km/h</td>
                                    <td>18m</td>
                                    <td>25m</td>
                                    <td>35m</td>
                                </tr>
                                <tr>
                                    <td>50 km/h</td>
                                    <td>35m</td>
                                    <td>50m</td>
                                    <td>60m</td>
                                </tr>
                                <tr>
                                    <td>60 km/h</td>
                                    <td>50m</td>
                                    <td>60m</td>
                                    <td>90m</td>
                                </tr>
                                <tr>
                                    <td>80 km/h</td>
                                    <td>60m</td>
                                    <td>90m</td>
                                    <td>120m</td>
                                </tr>
                                <tr>
                                    <td>100 km/h</td>
                                    <td>90m</td>
                                    <td>120m</td>
                                    <td>160m</td>
                                </tr>
                            </tbody>
               
                        </StyledTable>
                    </Li>
                   
                    <ListItem text="Additional measures (e.g. moving signs out, or using additional road signage) will be required if Good visibility distances cannot be achieved." />
                    <ListItem text="Sites with Poor visibility should be considered high risk." />
                    <ListItem text="Site with Very Good visibility can be low risk, subject to low traffic volumes and short works duration (< 15 mins)." />
                    <ListItem text="If relying on Visibility as a control measure, you must ensure a Very Good distance for the speed of the road." />
                </ul>
            )
        },
        tra_par: {
            name: "Parking",
            icon: tra_par,
            text: (
                <ul>
                    <ListItem text="Vehicles, not being used as part of the construction site, must be parked away from site traffic in designated areas." />
                </ul>
            )
        },

        tra_sta_pla: {
            name: "Standard Plan",
            icon: tra_sta_pla,
            text: (
                <ul>
                    <ListItem text="The selection of Standard Plans need to be assessed to ensure that all prescribed conditions are met" />
                    <ListItem text="This will include an assessment of conditions and risks" />
                    <ListItem text="They will give design information such as, locations, type of control, road details, traffic counts, timings and restrictions, and numbers and types of signs." />
                    <ListItem text="They give layout information, normally in the form of standard layout drawings and tables." />
                    <ListItem text="Safe Operating Procedures for the installation, (Operation), and removal" />
                    <ListItem text="May include an induction form for use by site workers." />
                    <Li>
                        <Typography variant="title">
                            On site you should have
                        </Typography>
                        <ol>
                            <ListItem text="A Safe System of Work Plan" />
                            <ListItem text="Layout drawing" />
                            <ListItem text="Site record of the installation" />
                        </ol>
                    </Li>
                </ul>
            )
        },

        tra_2_way_tra: {
            name: "2 Way Traffic",
            icon: tra_2_way_tra,
            text: (
                <ul>
                    <ListItem text="Can be used in all lighting conditions" />
                    <ListItem text="Should be used where it is safe to do so" />
                    <ListItem text="Can only be installed by trained operatives" />
                    <Li>
                        <Typography variant="title">
                            The unobstructed width must achieve the following
                        </Typography>
                        <StyledTable>
                            <th>
                                <td> </td>
                                <td>Individual Lane Width</td>
                                <td>`No Centre Line less than 60km/h`</td>
                                <td>No Centre Line 80/100 km/h</td>
                            </th>
                            <tr>
                                <td>Cars Only</td>
                                <td>>= 2.5m</td>
                                <td />
                                <td />
                            </tr>
                            <tr>
                                <td>HGVs Present</td>
                                <td>>= 3.0m</td>
                                <td />
                                <td />
                            </tr>
                            <tr>
                                <td>Preferred Width</td>
                                <td>3.3m </td>
                                <td>5.0 - 7.4m</td>
                                <td>6.0 - 7.4m</td>
                            </tr>
                            <tr>
                                <td>Preferred Width (with cyclists)</td>
                                <td>4.0 - 4.2m </td>
                                <td>6.0 - 7.4m</td>
                                <td>7.0 - 7.4m</td>
                            </tr>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        tra_giv_tak: {
            name: "Give & Take",
            icon: tra_giv_and_tak,
            text: (
                <ul>
                    <ListItem text="Can only be used  <=50 km/h, in daylight or lit areas." />
                    <ListItem text="Need clear visibility" />
                    <ListItem text="Max Length = 50m" />{" "}
                    <ListItem text="Max traffic to install = 20 veh/3 mins." />
                </ul>
            )
        },
        tra_pri: {
            name: "Priority",
            icon: tra_pri,
            text: (
                <ul>
                    <ListItem text="Can only be used in daylight or lit areas" />
                    <ListItem text="Maximum length = 80m" />
                    <ListItem text="Max traffic = 42 veh/3 mins." />
                    <Li>
                        <Typography variant="title">
                            Through visibility (with the dimension indicating
                            the distance before and after the site) must be
                            maintained as
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Speed</th>
                                    <th>
                                        Through visibility before/after site
                                    </th>
                                </tr>
                                <tr>
                                    <td>50 km/h</td>
                                    <td>≥ 60m</td>
                                </tr>
                                <tr>
                                    <td>60 km/h</td>
                                    <td>≥ 70m</td>
                                </tr>
                                <tr>
                                    <td>80 km/h</td>
                                    <td>≥ 80m</td>
                                </tr>
                                <tr>
                                    <td>100 km/h</td>
                                    <td>≥ 100m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                </ul>
            )
        },
        tra_sto_and_go: {
            name: "Stop & Go/ Marshall",
            icon: tra_sto_and_go,
            text: (
                <ul>
                    <ListItem text="Can only be used in daylight or lit areas" />
                    <Li>
                        <Typography variant="title">
                            Visibility requirements to the Stop/Go operators are
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>30 km/h</td>
                                    <td>25m</td>
                                </tr>
                                <tr>
                                    <td>50 km/h</td>
                                    <td>50m</td>
                                </tr>
                                <tr>
                                    <td>60 km/h</td>
                                    <td>60m</td>
                                </tr>
                                <tr>
                                    <td>80 km/h</td>
                                    <td>90m</td>
                                </tr>
                                <tr>
                                    <td>100 km/h</td>
                                    <td>120m</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Maximum shuttle length = 500m unless a site-specific plan is being used. Above 200m you need 2 operators. Up to 200m 1 operator with a remote board can be used, provided operator is < 100m away from each board. 1 Board can be used up to 20m." />
                    <Li>
                        <Typography variant="title">Max Traffic</Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <th>Shuttle Length</th>
                                    <th>Max Traffic/ 3 Min</th>
                                </tr>
                                <tr>
                                    <td>500m</td>
                                    <td>43</td>
                                </tr>
                                <tr>
                                    <td>500m</td>
                                    <td>43</td>
                                </tr>
                                <tr>
                                    <td>400m</td>
                                    <td>48</td>
                                </tr>
                                <tr>
                                    <td>300m</td>
                                    <td>53</td>
                                </tr>
                                <tr>
                                    <td>200m</td>
                                    <td>63</td>
                                </tr>
                                <tr>
                                    <td>100m</td>
                                    <td>70</td>
                                </tr>
                                <tr>
                                    <td>20m</td>
                                    <td>25</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Should only be undertaken by trained operatives. All approaches need to be under control." />
                    <ListItem text="Operatives need to stand in a safe location at the side of the road. They need to wear Class 3 high visibility PPE." />
                    <ListItem text="Continually monitor weather and light conditions for visibility, including sun dazzle." />
                    <ListItem text="All approaching traffic must be brought to a Stop, before being allowed to proceed through the site. One operator is required to be the “lead” operator (normally the clear lane)." />
                    <ListItem text="You must have a reliable communication system such as 2-way radios and, if possible, have intervisibility." />
                    <ListItem text="Marshalling is used where unobstructed width is <3.0m. If large vehicle needs to pass, then an all stop is implemented to allow the vehicle to pass while works are suspended. Site is then re-configured for normal Stop & Go operation and the all-stop released. " />
                </ul>
            )
        },
        tra_tra_sig: {
            name: "Traffic Signals",
            icon: tra_tra_sig,
            text: (
                <ul>
                    <ListItem text="Can only be used in all lighting conditions" />
                    <ListItem text="Should be vehicle actuated, except where inadvertent triggering of sensor will occur e.g. by pedestrian movements etc." />
                    <ListItem text=" You should have back-up Stop/Go discs on site, to deal with signal failures/traffic surges." />
                    <Li>
                        <Typography variant="title">
                            Visibility requirements to the signals are
                        </Typography>
                        <StyledTable>
                            <tr>
                                <td>30 km/h</td>
                                <td>25m</td>
                            </tr>
                            <tr>
                                <td>50 km/h</td>
                                <td>50m</td>
                            </tr>
                            <tr>
                                <td>60 km/h</td>
                                <td>60m</td>
                            </tr>
                            <tr>
                                <td>80 km/h</td>
                                <td>90m</td>
                            </tr>
                            <tr>
                                <td>100 km/h</td>
                                <td>120m</td>
                            </tr>
                        </StyledTable>
                    </Li>
                    <ListItem text="The height to the bottom of the red signal must be between 1.1m and 3.05m." />
                    <ListItem text="Maximum shuttle length = 500m unless a site-specific plan is being used. Choose shuttle length to suit works area requirements and longitudinal safety zones. Excessive shuttle lengths increase traffic build-up" />
                    <ListItem text="Should only be set-up by trained operatives. " />
                    <ListItem text="All approaches need to be under control." />
                    <ListItem text="The equipment operating manual/instructions need to be available on site" />
                    <ListItem text="Continually monitor weather and light conditions for visibility, including sun dazzle." />
                    <ListItem text="The signal timings should be adjusted to take account of traffic surges, am/pm tidal flows, by a trained operative." />
                    <Li>
                        <Typography variant="title">
                            Installation checks that should be undertaken
                        </Typography>
                        <ol>
                            <ListItem text="Batteries are fully charged with correct voltage (with a standby battery available for each signal)" />
                            <ListItem text="Check bulbs are operating" />
                            <ListItem text="Check traffic sensor is pointing in right direction and angle" />
                            <ListItem text="Check signals are communicating with each other/ timings are correct" />
                            <ListItem text="Check signal housing for damage and leaks" />
                            <ListItem text="Set-up timings as per training/manufacturer instructions relating to shuttle length. If shuttle distance changes, then timings should be adjusted." />
                            <ListItem text="You should observe 3 signal cycles, focusing on traffic being able to clear the shuttle and traffic queue development. Make any necessary adjustments." />
                        </ol>
                    </Li>
                </ul>
            )
        },
        tra_all_sto: {
            name: "All Stop",
            icon: tra_all,
            text: (
                <ul>
                    <ListItem text="All Stop should be used where adequate Lateral safety zones cannot be achieved past the works, or where traffic needs to be stopped temporarily to carry out work activities. Longitudinal Safety zone requirement should still be met." />
                </ul>
            )
        },
        tra_sem_sta: {
            name: "Semi-Static",
            icon: tra_sem_sta,
            text: (
                <ul>
                    <ListItem text="Can only be used in daylight or lit areas" />
                    <ListItem text="Maximum site length = 2km, but junction to junction preferred." />
                    <ListItem text="Work area must be continually moving or have only short duration stops ≤ 15 minutes" />
                    <Li>
                        <Typography variant="title">
                            Check for hazards affecting visibility
                        </Typography>
                        <ol>
                            <ListItem text="Levels or light," />
                            <ListItem text="Fog" />
                            <ListItem text=" Sun dazzle, or sun low on the horizon" />
                        </ol>
                    </Li>
                    <ListItem text="Risks are increased by high traffic volumes and speeds, or high number of junctions" />
                    <ListItem text="All workers must know the extent of the semi-static site" />
                    <ListItem text="You should not use this method where lane widths are ≥ 3.65m and there are full hard shoulders" />
                    <ListItem text="All vehicles used must have warning beacons visible 360 degress." />
                    <ListItem text="Work site vehicles should have blue arrow visible (only while working)" />
                    <Li>
                        <Typography variant="title">
                            Hard shoulder works{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Max Traffic = 130 veh/3 min." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">Give and Take</Typography>
                        <ol>
                            <ListItem text="Max Traffic = 20 veh/ 3 min." />
                            <ListItem text="Visibility to works is 160m for 80 km/h, 215m for 100 km/h." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">Stop and Go </Typography>
                        <ol>
                            <ListItem text="Stop and Go operator MUST stand in a safe location at the side of the road." />
                            <ListItem text="Max Traffic = 50 veh/ 3 min" />
                            <ListItem text="Visibility to Stop and Go is 90m for 80 km/h, 120m for 100 km/h" />
                        </ol>
                    </Li>
                </ul>
            )
        },

        tra_lia_per: {
            name: "Liaison/ Permission",
            icon: tra_lia_per,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            If stopping traffic, you will be required
                        </Typography>
                        <ol>
                            <ListItem text="To have the permission of the road authority." />
                            <ListItem text="To consult with the Gardaí." />
                        </ol>
                    </Li>
                    <ListItem text="If your work will interfere with services, you need to liaise with the relevant statutory undertaker." />
                    <ListItem text="If you are blocking an entrance/ private access, you will require the permission of the property owner." />
                    <ListItem text="If you are effecting a public transport point, you should liaise with the operator." />
                </ul>
            )
        },

        tra_add_sig: {
            name: "Additional Signage",
            icon: tra_add_sig,
            text: (
                <ul>
                    <ListItem text="Where adequate visibility cannot be achieved using the prescribed minimum number of signs, additional signage should be used or signs should be moved so that approaching drivers can see the sign at a minimum distance = cumulative distance + visibility requirement distance before the works." />
                </ul>
            )
        },
        tra_lig: {
            name: "Lighting",
            icon: tra_lig,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Adequate lighting levels and consistency must be
                            provided for operative access and work areas. For
                            guidance, minimum levels;
                        </Typography>
                        <ol>
                            <ListItem text="External circulation areas: 10 lx" />
                            <ListItem text="External Material handling areas: 10 lx" />
                            <ListItem text="Internal circulation areas: 5 lx" />
                            <ListItem text="Internal working areas: 15 lx" />
                            <ListItem text="Concreting: 50 lx" />
                            <ListItem text="Carpentry, joinery, blockwork, plastering: 100 lx" />
                            <ListItem text="Painting, decorating: 200 lx" />
                        </ol>
                        <Typography variant="title">
                            Total lumens = area (m2) x level (lx)/0.23
                            (utilisation)
                        </Typography>
                        <Typography variant="title">
                            Number of lights = total lumens/ lumen output of
                            light
                        </Typography>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            If using tower lighting
                        </Typography>
                        <ol>
                            <ListItem text="Ensure ground is stable" />
                            <ListItem text="Ensure no contact with overhead lines" />
                            <ListItem text="Only erect tower lighting during daylight" />
                            <ListItem text="Protect from vehicle impact" />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Adequate road lamps must be provided at roadworks
                            during hours of darkness in unlit areas{" "}
                        </Typography>
                        <ol>
                            <ListItem text="Steady state lamps along tapers (every 2nd cone)" />
                            <ListItem text="Steady state lamps or rotating reflectors along longitudinal cone runs (every 2nd cone)" />
                            <ListItem text="Flashing lamps are used only at points of danger" />
                        </ol>
                    </Li>
                </ul>
            )
        },
        tra_imp_pro_veh: {
            name: "Impact Protection Vehicle",
            icon: tra_ipv,
            text: (
                <ul>
                    <ListItem text="Should be used on Level 3 roads to protect live traffic from works that are not protected by static traffic management. May be used on other levels of roads." />
                    <ListItem text="Operatives cannot work of the back of the vehicle while it is providing crash protection." />
                    <ListItem text="A buffer distance of 50-100m must be provided in front of the vehicle to the works area. (This distance may be smaller on roads <60 km/h)" />
                    <ListItem text="While providing crash protection, the cushion must be down, automatic brake applied, rear arrow and light arrow pointing in the correct direction. Ballast weight may be required on the vehicle as per the manufacturer’s requirements." />
                    <ListItem text="You should not straddle lanes while providing crash protection." />
                </ul>
            )
        },
        tra_mob_roa: {
            name: "Mobile Road Works",
            icon: tra_mob_roa,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            {" "}
                            Before leaving yard check that IPV and all trailer
                            boards/vehicles are functioning correctly
                        </Typography>
                        <ol>
                            <ListItem text="3 point inertia seatbelts to be worn at all times" />
                            <ListItem text="Head restraints to be correctly positioned" />
                            <ListItem text="Min 1.5T kerb weight for trailer board vehicles" />
                        </ol>
                    </Li>
                    <ListItem text="Traffic count to be done before commencement and every 15 minutes during the closure" />
                    <Li>
                        <Typography variant="title">
                            As a rule of thumb
                        </Typography>
                        <ol>
                            <ListItem text="Lane 1 closure has max traffic count of 40 veh/ 3 min (Max HGV = 15 veh/ 3 min)" />
                            <ListItem text="All other lane closures have max traffic count of 60 veh/ 3 min/ per lane left open. (Max HGV = 20 veh/ 3 min/ lane left open)" />
                            <ListItem text="These guidelines are subject to 10% reduction if HGV content > 25%" />
                        </ol>
                    </Li>
                    <ListItem text="Max traffic count past slip roads = 25 veh/ 3 min on slip road (whether single or double)" />
                    <ListItem text="Max traffic count for hard shoulder works = 65 veh/ 3 min." />
                </ul>
            )
        },
        tra_veh_res_sys: {
            name: "Vehicle Restraint System",
            icon: tra_veh_res_sys,
            text: (
                <ul>
                    <ListItem text="These systems must be designed by a qualified designer" />
                    <ListItem text="They must be installed by operatives trained on the chosen system" />
                    <Li>
                        <Typography variant="title">
                            They must be installed in accordance with the method
                            statement/ manufacturer instructions
                        </Typography>
                        <ol>
                            <ListItem text="In accordance with minimum lengths" />
                            <ListItem text="In accordance with anchoring requirements" />
                            <ListItem text="In accordance with terminal ends requirements" />
                        </ol>
                    </Li>
                    <ListItem text="The specified working width behind the barrier must be kept clear of all plant, materials, equipment and operatives" />
                    <ListItem text="You are not permitted to make any modifications/ alterations to the installed barrier" />
                    <ListItem text="Any damage to the barrier must be reported to your supervisor." />
                </ul>
            )
        },
        tra_spe_con_con: {
            name: "Speed Control/ Convoy",
            icon: tra_spe_con,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            It is generally not advisable to solely rely on
                            posting speed limits to control speed. Speed control
                            is best achieved by the physical properties of the
                            site such as
                        </Typography>
                        <ol>
                            <ListItem text="Narrower lane widths" />
                            <ListItem text="Use of Stop/Go systems or Temporary Traffic Signals. On public roads this will require the permission of the road authority and consultation with the Gardaí." />
                            <ListItem text="Convoy vehicles." />
                        </ol>
                    </Li>
                    <Li>
                        <Typography variant="title">
                            Convoy vehicles should be operated at 20 km/h.
                            Generally shuttle lengths should be ≤ 500m. Traffic
                            volume should be ≤ 50 veh/3 min. Maximum convoyed
                            queues should ≤ 30 vehicles. The maximum time
                            between convoys should be ≤ 5 mins. The convoy
                            vehicle should have
                        </Typography>
                        <ol>
                            <ListItem text="4 wheels, " />
                            <ListItem text="conspicuous colour, " />
                            <ListItem text="good all round visibility, " />
                            <ListItem text="a tight turning signal " />
                            <ListItem text="warning beacons, visible 360o," />
                            <ListItem text="Have “Follow Me” fitted to rear." />
                            <ListItem text="Hazard lights should not be used (as they prevent use of turning indicators)" />
                        </ol>
                    </Li>
                    <ListItem text="The use of chicanes and ramps may be considered subject to them not introducing other risks for the operation of the plant." />
                    <Li>
                        <Typography variant="title">
                            While reducing site speed ≤ 30km/h will
                            significantly reduce the severity if an incident
                            were to occur, the overall risk can be greatly
                            reduced by reducing the likelihood of an incident
                            actually occurring. This can be achieved by
                        </Typography>
                        <ol>
                            <ListItem text="Providing segregation between your workers and traffic in the form of physical barriers or safety zones " />
                            <Li>
                                <Typography variant="title">
                                    Ensuring good visibility
                                </Typography>
                                <StyledTable>
                                    <tbody>
                                        <tr>
                                            <td>30 km/h</td>
                                            <td>35m</td>
                                        </tr>
                                        <tr>
                                            <td>50 km/h</td>
                                            <td>60m</td>
                                        </tr>
                                        <tr>
                                            <td>60 km/h</td>
                                            <td>90m</td>
                                        </tr>
                                        <tr>
                                            <td>80 km/h</td>
                                            <td>120m</td>
                                        </tr>
                                        <tr>
                                            <td>100 km/h</td>
                                            <td>160m</td>
                                        </tr>
                                    </tbody>
                                </StyledTable>
                            </Li>
                        </ol>
                    </Li>
                    <ListItem text="On sites where there are a large number of complex plant maneuvers in close proximity to workers, 20 km/h should be implemented." />
                </ul>
            )
        },

        tra_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: tra_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
